export default __webpack_public_path__ + "static/pastaroller-f250fafd4f2aa1749efa2b56792c9821.png";